import { useState } from 'react'
import { PopupButton } from 'react-calendly'
import { cn } from '@/lib/utils'
import { ContactFormModal } from './ContactFormModal'
import { useCalendlyRoot } from '../hooks/useCalendlyRoot'

const CALENDLY_URL = 'https://calendly.com/benepicks/demo'

export const FooterCTA = () => {
  const [contactModalOpen, setContactModalOpen] = useState(false)
  const rootElement = useCalendlyRoot()

  return (
    <section className="py-16 sm:py-20 lg:py-28 px-4 sm:px-6 lg:px-8 bg-[#0B0F19]">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-4 sm:mb-6 text-white leading-tight">
          Ready to modernize your benefits?
        </h2>
        <p className="text-base sm:text-lg md:text-xl mb-8 sm:mb-10 lg:mb-12 text-neutral-400 max-w-2xl mx-auto leading-relaxed px-4 sm:px-0">
          See how Benepicks can save you time and money in a live walkthrough.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 px-4 sm:px-0">
          {rootElement && (
            <PopupButton
              url={CALENDLY_URL}
              text="Book a Demo →"
              rootElement={rootElement}
              className={cn(
                'w-full sm:w-auto',
                'bg-orange-primary text-white',
                'px-8 sm:px-10 py-4 rounded-full',
                'text-base font-bold',
                'flex items-center justify-center gap-2.5',
                'hover:bg-orange-hover',
                'hover:-translate-y-0.5',
                'transition-all duration-200',
                'active:translate-y-0'
              )}
            />
          )}
          <button
            onClick={() => setContactModalOpen(true)}
            className={cn(
              'w-full sm:w-auto',
              'bg-white/10 backdrop-blur-sm text-white',
              'px-8 sm:px-10 py-4 rounded-full',
              'text-base font-bold',
              'border border-white/10',
              'hover:bg-white/15',
              'hover:border-white/20',
              'hover:-translate-y-0.5',
              'transition-all duration-200',
              'active:translate-y-0'
            )}
          >
            Contact Us
          </button>
        </div>
      </div>

      <ContactFormModal
        open={contactModalOpen}
        onOpenChange={setContactModalOpen}
      />
    </section>
  )
}
